var map = {
	"./100.svg": 2204,
	"./101.svg": 9565,
	"./102.svg": 6590,
	"./103.svg": 1231,
	"./104.svg": 3760,
	"./105.svg": 8145,
	"./106.svg": 1042,
	"./108.svg": 5140,
	"./109.svg": 2389,
	"./111.svg": 414,
	"./112.svg": 4589,
	"./113.svg": 5116,
	"./114.svg": 7680,
	"./116.svg": 3793,
	"./117.svg": 8256,
	"./118.svg": 6727,
	"./119.svg": 2902,
	"./15.svg": 7945,
	"./16.svg": 2922,
	"./18.svg": 124,
	"./19.svg": 9597,
	"./20.svg": 3373,
	"./21.svg": 9100,
	"./31.svg": 6579,
	"./32.svg": 5840,
	"./33.svg": 2753,
	"./34.svg": 926,
	"./35.svg": 8863,
	"./36.svg": 6188,
	"./39.svg": 1163,
	"./40.svg": 9331,
	"./41.svg": 6690,
	"./42.svg": 1233,
	"./43.svg": 8432,
	"./44.svg": 6991,
	"./47.svg": 5292,
	"./48.svg": 2939,
	"./50.svg": 1904,
	"./51.svg": 4145,
	"./52.svg": 9106,
	"./53.svg": 7043,
	"./54.svg": 8764,
	"./55.svg": 3037,
	"./56.svg": 8862,
	"./57.svg": 7791,
	"./62.svg": 4091,
	"./64.svg": 7397,
	"./65.svg": 148,
	"./66.svg": 951,
	"./76.svg": 4944,
	"./77.svg": 6065,
	"./79.svg": 5511,
	"./80.svg": 5551,
	"./81.svg": 1262,
	"./82.svg": 1981,
	"./92.svg": 2798,
	"./93.svg": 5375,
	"./94.svg": 7904,
	"./95.svg": 2705,
	"./96.svg": 962,
	"./97.svg": 4003,
	"./98.svg": 6964,
	"./default.svg": 314
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9829;